/*
 * - SABBANG PAHAYA GAMANEEYAN -
 * Created on Mon Sep 12 2022 9:41:42 AM
 *
 * By Kapila Rathnayaka
 *
 * Copyright (c) 2022 Kayble Zone Private Limited - Colombo Sri Lanka
 * Contact : http://www.kayblezone.lk - kapilarathnayaka@outlook.com
 */

import React, { useEffect, useReducer, useContext } from "react";
const { XMLParser } = require("fast-xml-parser");
import axios from 'axios';
import XMLData from '../data/biblio/master.xml' //master_20032023.xml

import ResourcesXMLData from '../data/resources/master-resources.xml'
import BlogsXMLData from '../data/blogs/master-blogs.xml'
import ProjectsXMLData from '../data/projects/master-projects.xml'
import HazardNotesXMLData from '../data/hazardnotes/master-hazardnotes.xml'
import FireAustraliaXMLData from '../data/fireaustralia/master.xml';

function reducer(state, action) {
    switch (action.type) {
        case "LOAD_BIBLIO_DATA": {
            return { ...state, nodes: action.payload };
        }
        case "LOAD_RESOURCES_DATA": {
            return { ...state, resourcesnodes: action.payload, currentContentType: "resources" };
        }
        case "LOAD_BLOGS_DATA": {
            return { ...state, blogsnodes: action.payload, currentContentType: 'blogs' };
        }
        case "LOAD_PROJECTS_DATA": {
            return { ...state, projectsnodes: action.payload, currentContentType: 'projects' };
        }
        case "LOAD_HAZARDNOTES_DATA": {
            return { ...state, hazardnotesnodes: action.payload, currentContentType: 'hazardnotes' };
        }
        case "LOAD_FIREAUSTRALIA_DATA": {
            return { ...state, fireaustralianodes: action.payload, currentContentType: 'fireaustralia' };
        }
        default: {
            throw new Error(`Unhandled action type: ${action.type}`);
        }
    }
}

const XMLDataContext = React.createContext();

const XMLDataContextControllerProvider = ({ children }) => {

    const initialState = {
        nodes: [],
        resourcesnodes: [],
        blogsnodes: [],
        projectsnodes: [],
        hazardnotesnodes: [],
        fireaustralianodes:[]
        // showSearchBox: true,
        // setShowSearch: () => { }
    };

    useEffect(() => {
        
        const pathname = window.location.pathname;
        
        if (pathname == '/biblio' || pathname == '/biblio/subindex' || pathname == '/biblio/node') {
            axios.get(XMLData, {
                "Content-Type": "application/xml; charset=utf-8"
                // "Content-Type":"application/xml;text/plain"
            })
                .then((response) => {
                    var xml = response.data;
                    const parser = new XMLParser();
                    var parsedXml = parser.parse(xml);

                    dispatch({ type: "LOAD_BIBLIO_DATA", payload: parsedXml.nodes.node })
                }).catch(error => console.log('error :' + error))
        }
        
        if (pathname == '/resources' || pathname == '/resources/subindex' || pathname == '/resources/node') {
            axios.get(ResourcesXMLData, {
                "Content-Type": "application/xml; charset=utf-8"
            })
                .then((response) => {
                    var xml = response.data;
                    const parser = new XMLParser();
                    var parsedXml = parser.parse(xml);
                    dispatch({ type: "LOAD_RESOURCES_DATA", payload: parsedXml.nodes.node })
                }).catch(error => console.log('error :' + error))
        }
        if (pathname == '/blogs' || pathname == '/blogs/subindex' || pathname == '/blogs/node') {
            axios.get(BlogsXMLData, {
                "Content-Type": "application/xml; charset=utf-8"
            })
                .then((response) => {
                    var xml = response.data;
                    const parser = new XMLParser();
                    var parsedXml = parser.parse(xml);
                    dispatch({ type: "LOAD_BLOGS_DATA", payload: parsedXml.nodes.node })
                }).catch(error => console.log('error :' + error))
        }
        if (pathname == '/projects' || pathname == '/projects/subindex' || pathname == '/projects/node') {
            axios.get(ProjectsXMLData, {
                "Content-Type": "application/xml; charset=utf-8"
            })
                .then((response) => {
                    var xml = response.data;
                    const parser = new XMLParser();
                    var parsedXml = parser.parse(xml);
                    dispatch({ type: "LOAD_PROJECTS_DATA", payload: parsedXml.nodes.node })
                }).catch(error => console.log('error :' + error))
        }
        if (pathname == '/hazardnotes' || pathname == '/hazardnotes/subindex' || pathname == '/hazardnotes/node') {
            axios.get(HazardNotesXMLData, {
                "Content-Type": "application/xml; charset=utf-8"
            })
                .then((response) => {
                    var xml = response.data;
                    const parser = new XMLParser();
                    var parsedXml = parser.parse(xml);
                    dispatch({ type: "LOAD_HAZARDNOTES_DATA", payload: parsedXml.nodes.node })
                }).catch(error => console.log('error :' + error))
        }
        if (pathname == '/fireaustralia' || pathname == '/fireaustralia/subindex' || pathname == '/fireaustralia/node') {
            axios.get(FireAustraliaXMLData, {
                "Content-Type": "application/xml; charset=utf-8"
            })
                .then((response) => {
                    var xml = response.data;
                    const parser = new XMLParser();
                    var parsedXml = parser.parse(xml);
                    dispatch({ type: "LOAD_FIREAUSTRALIA_DATA", payload: parsedXml.nodes.node })
                }).catch(error => console.log('error :' + error))
        }
    }, [])
    const [controller, dispatch] = useReducer(reducer, initialState);
    const contextValue = [controller, dispatch];
    return <XMLDataContext.Provider value={contextValue}>{children}</XMLDataContext.Provider>
}

function useXMLDataContextController() {
    const context = useContext(XMLDataContext);
    const { basename } = context || {};
    if (!context) {
        throw new Error(
            "useXMLDataContextController should be used inside the ControllerProvider."
        );
    }
    return context;
}

export {
    XMLDataContextControllerProvider,
    useXMLDataContextController
};